import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row justify-between select-channel-trigger" }
const _hoisted_2 = { class: "column fit" }
const _hoisted_3 = { class: "row justify-between no-wrap q-mt-xs" }
const _hoisted_4 = { class: "row q-mt-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_required_input_refactor = _resolveComponent("required-input-refactor")!
  const _component_select_chanel_button = _resolveComponent("select-chanel-button")!
  const _component_disabled_button_wrapper = _resolveComponent("disabled-button-wrapper")!
  const _component_common_button = _resolveComponent("common-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredInputs, (input, key) => {
        return (_openBlock(), _createBlock(_component_required_input_refactor, {
          key: key,
          "type-of-input": key,
          control: input,
          showInvalidRequiredInput: _ctx.showInvalidRequiredInputs,
          "display-type": "trigger",
          onChangeControl: _ctx.emitChangeControl,
          class: "q-mt-xs"
        }, null, 8, ["type-of-input", "control", "showInvalidRequiredInput", "onChangeControl"]))
      }), 128)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons.selectChannelButtons, (button, index) => {
          return (_openBlock(), _createBlock(_component_disabled_button_wrapper, {
            key: index,
            disabled: _ctx.disableButton,
            onDisabledClick: ($event: any) => (_ctx.emitClickButton(button)),
            class: "select-channel-button fit"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_select_chanel_button, {
                button: button,
                disabled: _ctx.disableButton,
                message: _ctx.message,
                "show-text": false,
                displayType: "trigger",
                onClick: ($event: any) => (_ctx.emitClickButton(button))
              }, null, 8, ["button", "disabled", "message", "onClick"])
            ]),
            _: 2
          }, 1032, ["disabled", "onDisabledClick"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons.commonButtons, (button, key) => {
          return (_openBlock(), _createBlock(_component_disabled_button_wrapper, {
            disabled: _ctx.disableButton,
            key: key,
            onDisabledClick: ($event: any) => (_ctx.emitClickButton(button)),
            class: "fit common-button"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_common_button, {
                button: button,
                disabled: _ctx.disableButton,
                onClick: ($event: any) => (_ctx.emitClickButton(button)),
                class: "fit"
              }, null, 8, ["button", "disabled", "onClick"])
            ]),
            _: 2
          }, 1032, ["disabled", "onDisabledClick"]))
        }), 128))
      ])
    ])
  ]))
}